import React from 'react'
import { useIntl } from 'react-intl'

import { Button } from '../../../components/Button/Button'
import { GrainCard } from '../../../components/GrainCard'
import { Section } from '../../../components/Section'
import { TextLayout } from '../../../components/TextLayout'
import { WebsiteText } from '../../../components/WebsiteText'
import { useRoutes } from '../../../routes'
import askAnywhereIllustration from './assets/ask-anywhere.svg'
import knowledgeBaseIllustration from './assets/knowledge-base.svg'
import maintenanceIllustration from './assets/maintenance.svg'

export function SectionHomeCategories() {
  const intl = useIntl()
  const routes = useRoutes()

  const content = [
    {
      title: intl.formatMessage({
        id: 'home.categories.docs.title',
        defaultMessage: 'Everything your team knows, in one place.',
      }),
      illustration: knowledgeBaseIllustration,
      button: (
        <Button
          href={routes.features()}
          variant="secondary"
          style={{ width: 'fit-content' }}
        >
          {intl.formatMessage({
            id: 'home.categories.docs.button',
            defaultMessage: 'See the knowledge base',
          })}
        </Button>
      ),
    },
    {
      title: intl.formatMessage({
        id: 'home.categories.agent.title',
        defaultMessage: 'Outdated documents get rewritten for you.',
      }),
      illustration: maintenanceIllustration,
      button: (
        <Button
          href={routes.agent()}
          variant="secondary"
          style={{
            width: 'fit-content',
          }}
        >
          {intl.formatMessage({
            id: 'home.categories.agent.button',
            defaultMessage: 'See Slite Agent',
          })}
        </Button>
      ),
    },
    {
      title: intl.formatMessage({
        id: 'home.categories.search.title',
        defaultMessage: 'Answers for your team and your AI, wherever they ask.',
      }),
      illustration: askAnywhereIllustration,
      button: (
        <Button
          href={routes.aiSearch()}
          variant="secondary"
          style={{
            width: 'fit-content',
          }}
        >
          {intl.formatMessage({
            id: 'home.categories.search.button',
            defaultMessage: 'See AI search',
          })}
        </Button>
      ),
    },
  ]

  const header = {
    title: intl.formatMessage({
      id: 'home.categories.heading.title',
      defaultMessage: 'The AI knowledge base that does the whole job',
    }),
  }

  return (
    <Section
      background="moon-dust-lighter"
      containerVerticalPadding={120}
      className="text-align-center"
    >
      <TextLayout type="centered" title={header.title} titleMaxWidth={620} />
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          gap: '24px',
          width: '100%',
        }}
      >
        {content.map((c) => (
          <GrainCard
            key={c.title}
            style={{
              minWidth: 240,
              flex: '1',
              textAlign: 'center',
              padding: '48px 24px 0',
              display: 'flex',
              flexDirection: 'column',
              gap: 20,
              alignItems: 'center',
              overflow: 'hidden',
            }}
          >
            <WebsiteText
              variant="title"
              className="shade-00"
              style={{ maxWidth: 280, fontSize: 28 }}
            >
              {c.title}
            </WebsiteText>
            {c.button}
            <img
              src={c.illustration}
              alt=""
              aria-hidden
              draggable={false}
              style={{
                display: 'block',
                width: 'calc(100% + 48px)',
                maxWidth: 'none',
                height: 'auto',
                aspectRatio: '387 / 342',
                margin: 'auto -24px 0',
              }}
            />
          </GrainCard>
        ))}
      </div>
    </Section>
  )
}
